module.exports = __webpack_public_path__ + "static/media/tutorial_basics.b4dcd79c.jpg";